import { render, staticRenderFns } from "./PopupPostSelect.vue?vue&type=template&id=4a71650d&scoped=true"
import script from "./PopupPostSelect.vue?vue&type=script&lang=js"
export * from "./PopupPostSelect.vue?vue&type=script&lang=js"
import style0 from "./PopupPostSelect.vue?vue&type=style&index=0&id=4a71650d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71650d",
  null
  
)

export default component.exports